import styled from 'styled-components';

export default styled.div`
  color: #b4b4b4;
  font-size: 0.8rem;
  margin-left: 2rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
